import { FC } from 'react';
import MonitoringCommonFilters from '../../Monitoring/MonitoringCommonFilters';
import { Button } from 'primereact/button';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setReportsFilter } from '../../../redux/reducers/filterReportsSlice';
import { reportsFilterInitialState } from '../../../models/ReportsFilter';
import {
  selectedDiagnosticReportsFilter,
  setDiagnosticReportsFilter,
} from '../../../redux/reducers/filterDiagnosticReport';
import { selectUser } from '../../../redux/reducers/userSlice';
import { Site } from '../../../models/Site';

interface Props {
  singleClassDropdown?: boolean;
}

const ProgressFilters: FC<Props> = ({ singleClassDropdown }) => {
  const dispatch = useAppDispatch();
  const diagnosticReportFilters = useAppSelector(selectedDiagnosticReportsFilter);
  const user = useAppSelector(selectUser);

  const clearFilters = () => {
    const onlySite: Site | undefined =
      Array.isArray(user?.sites) && user?.sites.length === 1 ? (user.sites[0] as Site) : undefined;

    if (onlySite) {
      dispatch(
        setReportsFilter({
          ...reportsFilterInitialState,
          sites: onlySite,
          classes: [],
          roadmaps: { id: '', name: '' },
        }),
      );
    } else {
      dispatch(setReportsFilter(reportsFilterInitialState));
    }
    if (singleClassDropdown) {
      dispatch(
        setDiagnosticReportsFilter({
          ...diagnosticReportFilters,
          classes: [],
          roadmap: null,
        }),
      );
    }
  };

  return (
    <div className="col-12">
      <div
        className="grid nc_filters align-items-center py-3 px-4"
        style={{ backgroundColor: 'white', borderRadius: '8px' }}
      >
        <MonitoringCommonFilters singleClassDropdown={singleClassDropdown} />
        <Button
          className="ml-auto"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            clearFilters();
          }}
          label="Reset All"
          link
          rounded
        />
      </div>
    </div>
  );
};

export default ProgressFilters;
